<div fxLayout="column" fxLayoutAlign="center" fxFlex="40%" class="component-container">
  <mat-stepper orientation='horizontal' #stepper>
    <ng-template matStepperIcon="edit" fxLayout="row" fxLayoutAlign="center">
      <div class="logo"></div>
    </ng-template>

    <mat-step state="account">
      <app-account [invite]="invite" (data)="onAccountCreated($event)"></app-account>
    </mat-step>

<!--    <mat-step state="brands">-->
<!--      <ng-template matStepContent>-->
<!--        <app-brands-->
<!--          [data]="data"-->
<!--          (emitBrands)="consumeBrands($event)"-->
<!--          (emitStripeInfo)="continueToPayment($event)"-->
<!--        ></app-brands>-->
<!--      </ng-template>-->
<!--    </mat-step>-->

    <!--    User should be booted out to before this step if not being billed through stripe-->
<!--    <mat-step state="payment">-->
<!--      <ng-template matStepContent>-->
<!--        <app-payment [data]="subIds" (onCardCreated)="onCardCreated($event)"></app-payment>-->
<!--      </ng-template>-->
<!--    </mat-step>-->

<!--    <mat-step state="review">-->
<!--      <ng-template matStepContent>-->
<!--        <ng-container *ngIf="paymentOptions">-->
<!--          <app-payment-options-->
<!--            [brands]="brands"-->
<!--            [user]="user"-->
<!--            [cardInfoData]="cardInfoData"-->
<!--            [subIds]="subIds"-->
<!--            (allCards)="ingestCards($event)"-->
<!--            (brandsWithCardToDisplay)="ingestBrandsToDisplay($event)"-->
<!--            (completed)="checkIngest($event)"-->
<!--          ></app-payment-options>-->
<!--        </ng-container>-->

<!--        <ng-container *ngIf="!paymentOptions">-->
<!--          <div fxLayout="row" fxLayoutAlign="center" class="step-header">Payment Confirmation</div>-->
<!--          <div fxLayout="row" fxLayoutAlign="center">-->
<!--            <span class="sub-header" fxFlex="40%">holder</span>-->
<!--          </div>-->

<!--          <div fxLayout="row">-->
<!--            <div>-->
<!--              <div>-->
<!--                <span fxLayout="row">-->
<!--                  <h4 class="no-wrap">Personal Information</h4>-->
<!--                  <mat-icon fxLayoutAlign="end center" class="reviewHover" (click)="move(0)">create</mat-icon>-->
<!--                </span>-->
<!--                <p class="no-wrap">{{ user.firstName }} {{ user.lastName }}</p>-->
<!--                <p>{{ user.email }}</p>-->
<!--              </div>-->
<!--              <div>-->
<!--                <span fxLayout="row">-->
<!--                  <h4 class="no-wrap">Brands</h4>-->
<!--                  <mat-icon fxLayoutAlign="end center" class="reviewHover" (click)="move(1)">create</mat-icon>-->
<!--                </span>-->
<!--                <div *ngFor="let brand of brands">-->
<!--                  <p class="no-wrap">{{ brand.name }}</p>-->
<!--                </div>-->
<!--              </div>-->
<!--              <div>-->
<!--                <span fxLayout="row">-->
<!--                  <h4 class="no-wrap">Payment Information</h4>-->
<!--                  <mat-icon fxLayoutAlign="end center" class="reviewHover" (click)="move(2)">create</mat-icon>-->
<!--                </span>-->
<!--                <div *ngFor="let lastFour of cards">-->
<!--                  <p>{{ lastFour.card }}</p>-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
<!--            <div style="padding: 10px" fxFlex="20%"></div>-->
<!--            <mat-card class="review-card" fxLayout="column">-->
<!--              <mat-card-title> Order Review </mat-card-title>-->
<!--              <mat-card-content fxLayout="column" fxLayoutAlign="center">-->
<!--                <div class="review-total" *ngFor="let brand of brandsForDisplay">-->
<!--                  <div>{{ brand.card }}</div>-->

<!--                  <div class="brand-total" fxLayout="row" fxLayoutAlign="space-between center">-->
<!--                    <div style="text-indent: 30px">{{ brand.name }}</div>-->
<!--                    <div *ngIf="brand.interval === 'month'" class="grey-text">$x/month</div>-->
<!--                    <div *ngIf="brand.interval === 'year'" class="grey-text">$x/year</div>-->
<!--                  </div>-->

<!--                  <div class="grey-text" fxLayout="row" fxLayoutAlign="space-between center">-->
<!--                    <div>Today's Total</div>-->
<!--                    <div>$xx</div>-->
<!--                  </div>-->

<!--                  <div-->
<!--                    *ngIf="brand.interval === 'month'"-->
<!--                    class="grey-text"-->
<!--                    fxLayout="row"-->
<!--                    fxLayoutAlign="space-between center"-->
<!--                  >-->
<!--                    <div>Monthly Total*</div>-->
<!--                    <div fxLayoutAlign="">$xx/month</div>-->
<!--                  </div>-->
<!--                  <div-->
<!--                    *ngIf="brand.interval === 'year'"-->
<!--                    class="grey-text"-->
<!--                    fxLayout="row"-->
<!--                    fxLayoutAlign="space-between center"-->
<!--                  >-->
<!--                    <div>Yearly Total*</div>-->
<!--                    <div fxLayoutAlign="">$xx/year</div>-->
<!--                  </div>-->
<!--                </div>-->
<!--                <p class="small-text">-->
<!--                  * Total to be billed every month. You can add or subtract brands or cancel at any time.-->
<!--                </p>-->
<!--              </mat-card-content>-->
<!--              <mat-card-actions fxlayoutAlign="center center">-->
<!--                <button mat-raised-button color="primary" (click)="goToHome()">PAY AND CONTINUE TO HOME</button>-->
<!--              </mat-card-actions>-->
<!--            </mat-card>-->
<!--          </div>-->
<!--        </ng-container>-->
<!--      </ng-template>-->
<!--    </mat-step>-->
  </mat-stepper>
</div>
